import type { GetAdminMatters } from '@cloudFunctions/types/admin/getAdminMatters';
import type { BackendPathParams, BackendRouteDefinition } from '../types';

// Migrated to `api-core-node` in PRA-794 (Phase 5 Sub-phase 6, S6-WB1) —
// admin reads share the same service as the other admin Finix / firms
// endpoints. The cloudFunctions callable was retired in S9-WB2 (PRA-804);
// the type-only `GetAdminMatters` namespace at the import path above
// remains the canonical wire contract.
//
// The path lives under the `:firmId` / optional `:matterId?` template so
// admin callers can reach either the per-firm list or a single matter
// without changing transports. `/api/**` routes default to api-core-node
// in firebase.json and the admin Vite proxy, so no extra rewrite is
// needed.
export const getAdminMattersRoute = {
  transport: 'api',
  method: 'GET',
  path: '/admin/matters/:firmId/:matterId?',
  params: (requestData?: GetAdminMatters.Props): BackendPathParams => {
    if (!requestData) {
      return {};
    }
    const params: BackendPathParams = { firmId: requestData.firmId };
    if (requestData.matterId) {
      params.matterId = requestData.matterId;
    }
    return params;
  },
  query: (requestData?: GetAdminMatters.Props) => ({
    includePaymentInstruments: requestData?.includePaymentInstruments,
    finixEnvironment: requestData?.finixEnvironment,
    batchSize: requestData?.batchSize,
  }),
} as const satisfies BackendRouteDefinition;
